function NewQuotaParameterValue() {
    return {
        id: null,       
        demoQuestionId: null,
		answerCodes: null,
        regionCode: null
      }
}
export default NewQuotaParameterValue;